import { render } from "./Perizia.vue?vue&type=template&id=5b963753"
import script from "./Perizia.vue?vue&type=script&lang=js"
export * from "./Perizia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__